<script setup lang="ts">
import { Link } from '~/lib/services/content/content.shared.dtos'

defineProps<{
  section: Link
}>()
</script>

<template>
  <div class="cursor-pointer">
    <NuxtLink :to="section?.url || section?.page?.path" class="block rounded py-3 text-lg">
      <p>{{ section.title }}</p>
    </NuxtLink>
  </div>
</template>

<style scoped>
.router-link-active {
  @apply border-b-4 border-b-mcd-main;
}
</style>
